import logo from "./logo.svg";
import "./App.css";
import { useEffect, useState } from "react";
import Papa from "papaparse";
import axios from "axios";
import moment from "moment";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";

function App() {
  const [companies, setCompanies] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    active: false,
    key: null,
    direction: null,
  });

  useEffect(() => {
    // Specifică calea relativă a fișierului CSV
    const csvFilePath = "./punctaj.csv";

    // get data with axios from https://py.iluminatsolar.com/pnrr
    axios
      .get("https://py.iluminatsolar.com/pnrr")
      .then((responseax) => {
        // Citește fișierul CSV folosind fetch
        fetch(csvFilePath)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to fetch CSV file");
            }
            return response.text(); // Obține conținutul fișierului ca text
          })
          .then((csvText) => {
            // Parsează conținutul CSV folosind papaparse
            Papa.parse(csvText, {
              header: true, // Setează la true dacă fișierul are antet
              skipEmptyLines: true,
              complete: (results) => {
                results.data.forEach((company) => {
                  const companyFromAPI = responseax.data.find(
                    (c) => parseInt(c.cui) === parseInt(company.CUI)
                  );
                  if (companyFromAPI) {
                    let aux = [...responseax.data];
                    let index = aux.findIndex(
                      (c) => parseInt(c.cui) === parseInt(company.CUI)
                    );
                    let diff = 0;
                    let nrdosare = 0;
                    let bugetInainte = 0;
                    let bugetDupa = 0;
                    if (index > 0 && aux[index].not_sure === "0") {
                      diff =
                        parseInt(aux[index].total_value) -
                        parseInt(aux[index - 1].total_value);
                      bugetInainte = parseInt(aux[index - 1].total_value);
                      bugetDupa = parseInt(aux[index].total_value);

                      nrdosare = diff / 24883 / 1.19;
                    }

                    company["PUNCTAJ_TOTAL"] =
                      parseFloat(company["PunctajA+B"]) +
                      (diff * 0.4) / 24883000 / 1.19;
                    company["PUNCTAJ_DOSARE"] = (diff * 0.4) / 24883000 / 1.19;
                    company["PunctajA+B"] = parseFloat(company["PunctajA+B"]);
                    company["SELECTED"] = true;
                    company["NOT_SURE"] = aux[index].not_sure;
                    company["NR_DOSARE"] = nrdosare;
                    company["BUGET_INAINTE"] = bugetInainte;
                    company["BUGET_DUPA"] = bugetDupa;

                    company["TRIMIS_LA"] = aux[index].send_at;
                  } else {
                    company["PUNCTAJ_TOTAL"] = 0;
                    company["PUNCTAJ_DOSARE"] = 0;
                    company["PunctajA+B"] = 0;
                    company["SELECTED"] = false;
                    company["NOT_SURE"] = 0;
                    company["NR_DOSARE"] = 0;
                    company["BUGET_INAINTE"] = 0;
                    company["BUGET_DUPA"] = 0;
                    company["TRIMIS_LA"] = null;
                  }
                });
                setCompanies(results.data);
              },
              error: (error) => {
                console.error("Error parsing CSV:", error);
              },
            });
          })
          .catch((error) => {
            console.error("Error reading CSV file:", error);
          });
      })
      .catch((error) => {
        console.error("Error fetching data from API:", error);
      });
  }, []);

  const handleSort = (key) => {
    if (sortConfig.active == false) {
      setSortConfig({
        active: true,
        key: key,
        direction: "asc",
      });
    } else {
      if (sortConfig.key != key) {
        setSortConfig({
          active: true,
          key: key,
          direction: "asc",
        });
      } else if (sortConfig.direction == "asc") {
        setSortConfig({
          active: true,
          key: key,
          direction: "desc",
        });
      } else {
        setSortConfig({
          active: false,
          key: key,
          direction: "asc",
        });
      }
    }
  };

  const sortedData = [...companies];
  if (sortConfig.active != false) {
    if (sortConfig.key == "nume") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => (a.NUME > b.NUME ? 1 : -1));
      } else {
        sortedData.sort((a, b) => (a.NUME < b.NUME ? 1 : -1));
      }
    }
    if (sortConfig.key == "cui") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => (a.CUI > b.CUI ? 1 : -1));
      } else {
        sortedData.sort((a, b) => (a.CUI < b.CUI ? 1 : -1));
      }
    }
    if (sortConfig.key == "judet") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => (a.JUDET > b.JUDET ? 1 : -1));
      } else {
        sortedData.sort((a, b) => (a.JUDET < b.JUDET ? 1 : -1));
      }
    }
    if (sortConfig.key == "buget_inainte") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => (a.BUGET_INAINTE > b.BUGET_INAINTE ? 1 : -1));
      } else {
        sortedData.sort((a, b) => (a.BUGET_INAINTE < b.BUGET_INAINTE ? 1 : -1));
      }
    }
    if (sortConfig.key == "buget_dupa") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => (a.BUGET_DUPA > b.BUGET_DUPA ? 1 : -1));
      } else {
        sortedData.sort((a, b) => (a.BUGET_DUPA < b.BUGET_DUPA ? 1 : -1));
      }
    }
    if (sortConfig.key == "trimis_la") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => {
          if (a.TRIMIS_LA == null) {
            return 1;
          }
          if (b.TRIMIS_LA == null) {
            return -1;
          }
          return moment(a.TRIMIS_LA, "DD-MM-YYYY HH:mm:ss.SSS").isBefore(
            moment(b.TRIMIS_LA, "DD-MM-YYYY HH:mm:ss.SSS")
          ) == true
            ? -1
            : 1;
        });
      } else {
        sortedData.sort((a, b) => {
          if (a.TRIMIS_LA == null) {
            return 1;
          }
          if (b.TRIMIS_LA == null) {
            return -1;
          }
          return moment(a.TRIMIS_LA, "DD-MM-YYYY HH:mm:ss.SSS").isBefore(
            moment(b.TRIMIS_LA, "DD-MM-YYYY HH:mm:ss.SSS")
          ) == true
            ? 1
            : -1;
        });
      }
    }
    if (sortConfig.key == "nr_dosare") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => (a.NR_DOSARE > b.NR_DOSARE ? 1 : -1));
      } else {
        sortedData.sort((a, b) => (a.NR_DOSARE < b.NR_DOSARE ? 1 : -1));
      }
    }
    if (sortConfig.key == "punctajab") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => (a["PunctajA+B"] > b["PunctajA+B"] ? 1 : -1));
      } else {
        sortedData.sort((a, b) => (a["PunctajA+B"] < b["PunctajA+B"] ? 1 : -1));
      }
    }
    if (sortConfig.key == "punctaj_dosare") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) =>
          a["PUNCTAJ_DOSARE"] > b["PUNCTAJ_DOSARE"] ? 1 : -1
        );
      } else {
        sortedData.sort((a, b) =>
          a["PUNCTAJ_DOSARE"] < b["PUNCTAJ_DOSARE"] ? 1 : -1
        );
      }
    }
    if (sortConfig.key == "punctaj_total") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) =>
          parseFloat(a.PUNCTAJ_TOTAL) > b.PUNCTAJ_TOTAL ? 1 : -1
        );
      } else {
        sortedData.sort((a, b) => (a.PUNCTAJ_TOTAL < b.PUNCTAJ_TOTAL ? 1 : -1));
      }
    }

    if (sortConfig.key == "programat") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => {
          return moment(a.programat).isBefore(b.programat) == true ? -1 : 1;
        });
      } else {
        sortedData.sort((a, b) => {
          return moment(a.programat).isBefore(b.programat) == true ? 1 : -1;
        });
      }
    }
    if (sortConfig.key == "prezentat") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => {
          if (a.prezentat == null) {
            return 1;
          }
          if (b.prezentat == null) {
            return -1;
          }
          return moment(a.prezentat).isBefore(b.prezentat) == true ? -1 : 1;
        });
      } else {
        sortedData.sort((a, b) => {
          if (a.prezentat == null) {
            return 1;
          }
          if (b.prezentat == null) {
            return -1;
          }
          return moment(a.prezentat).isBefore(b.prezentat) == true ? 1 : -1;
        });
      }
    }
    if (sortConfig.key == "consultat") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => {
          if (a.consultat == null) {
            return 1;
          }
          if (b.consultat == null) {
            return -1;
          }
          return moment(a.consultat).isBefore(b.consultat) == true ? -1 : 1;
        });
      } else {
        sortedData.sort((a, b) => {
          if (a.consultat == null) {
            return 1;
          }
          if (b.consultat == null) {
            return -1;
          }
          return moment(a.consultat).isBefore(b.consultat) == true ? 1 : -1;
        });
      }
    }
    if (sortConfig.key == "final") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => {
          if (a.final == null) {
            return 1;
          }
          if (b.final == null) {
            return -1;
          }
          return moment(a.final).isBefore(b.final) == true ? -1 : 1;
        });
      } else {
        sortedData.sort((a, b) => {
          if (a.final == null) {
            return 1;
          }
          if (b.final == null) {
            return -1;
          }
          return moment(a.final).isBefore(b.final) == true ? 1 : -1;
        });
      }
    }
    if (sortConfig.key == "ochelari") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => {
          let countA = 0;
          let countB = 0;
          if (a.ochelari) {
            countA = countA + 1;
          }
          if (a.lentile) {
            countA = countA + 1;
          }
          if (b.ochelari) {
            countB = countB + 1;
          }
          if (b.lentile) {
            countB = countB + 1;
          }
          return countA > countB ? -1 : 1;
        });
      } else {
        sortedData.sort((a, b) => {
          let countA = 0;
          let countB = 0;
          if (a.ochelari) {
            countA = countA + 1;
          }
          if (a.lentile) {
            countA = countA + 1;
          }
          if (b.ochelari) {
            countB = countB + 1;
          }
          if (b.lentile) {
            countB = countB + 1;
          }
          return countA > countB ? 1 : -1;
        });
      }
    }
    if (sortConfig.key == "total") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => {
          let priceA = a.final_price != null ? a.final_price : a.expected_price;
          let priceB = b.final_price != null ? b.final_price : b.expected_price;
          return priceA > priceB ? 1 : -1;
        });
      } else {
        sortedData.sort((a, b) => {
          let priceA = a.final_price != null ? a.final_price : a.expected_price;
          let priceB = b.final_price != null ? b.final_price : b.expected_price;
          return priceA > priceB ? -1 : 1;
        });
      }
    }
    if (sortConfig.key == "doctor") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => (a.doctor > b.doctor ? 1 : -1));
      } else {
        sortedData.sort((a, b) => (a.doctor < b.doctor ? 1 : -1));
      }
    }

    if (sortConfig.key == "doctor_close") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => {
          if (a.doctor_close == null) {
            return -1;
          }
          if (b.doctor_close == null) {
            return 1;
          }
          return a.doctor_close?.full_name > b.doctor_close?.full_name ? 1 : -1;
        });
      } else {
        sortedData.sort((a, b) => {
          if (a.doctor_close == null) {
            return 1;
          }
          if (b.doctor_close == null) {
            return -1;
          }
          return a.doctor_close?.full_name < b.doctor_close?.full_name ? 1 : -1;
        });
      }
    }
    if (sortConfig.key == "observatii") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => {
          let obsA = a.pacient_obs
            ? a.pacient_obs
            : a.booking_obs
            ? a.booking_obs
            : a.online_obs
            ? a.online_obs
            : "";
          let obsB = b.pacient_obs
            ? b.pacient_obs
            : b.booking_obs
            ? b.booking_obs
            : b.online_obs
            ? b.online_obs
            : "";
          return obsA > obsB ? 1 : -1;
        });
      } else {
        sortedData.sort((a, b) => {
          let obsA = a.pacient_obs
            ? a.pacient_obs
            : a.booking_obs
            ? a.booking_obs
            : a.online_obs
            ? a.online_obs
            : "";
          let obsB = b.pacient_obs
            ? b.pacient_obs
            : b.booking_obs
            ? b.booking_obs
            : b.online_obs
            ? b.online_obs
            : "";
          return obsA > obsB ? -1 : 1;
        });
      }
    }
    if (sortConfig.key == "fisiere") {
      if (sortConfig.direction == "asc") {
        sortedData.sort((a, b) => {
          let filesA = 0;
          let filesB = 0;
          if (a.pdfs?.is_consult == true || a.pdfs?.is_consult == 1) {
            filesA = filesA + 1;
          }
          if (a.pdfs?.is_rp == true || a.pdfs?.is_rp == 1) {
            filesA = filesA + 1;
          }
          if (a.pdfs?.is_och == true || a.pdfs?.is_och == 1) {
            filesA = filesA + 1;
          }
          if (b.pdfs?.is_consult == true || b.pdfs?.is_consult == 1) {
            filesB = filesB + 1;
          }
          if (b.pdfs?.is_rp == true || b.pdfs?.is_rp == 1) {
            filesB = filesB + 1;
          }
          if (b.pdfs?.is_och == true || b.pdfs?.is_och == 1) {
            filesB = filesB + 1;
          }
          return filesA > filesB ? 1 : -1;
        });
      } else {
        sortedData.sort((a, b) => {
          let filesA = 0;
          let filesB = 0;
          if (a.pdfs?.is_consult == true || a.pdfs?.is_consult == 1) {
            filesA = filesA + 1;
          }
          if (a.pdfs?.is_rp == true || a.pdfs?.is_rp == 1) {
            filesA = filesA + 1;
          }
          if (a.pdfs?.is_och == true || a.pdfs?.is_och == 1) {
            filesA = filesA + 1;
          }
          if (b.pdfs?.is_consult == true || b.pdfs?.is_consult == 1) {
            filesB = filesB + 1;
          }
          if (b.pdfs?.is_rp == true || b.pdfs?.is_rp == 1) {
            filesB = filesB + 1;
          }
          if (b.pdfs?.is_och == true || b.pdfs?.is_och == 1) {
            filesB = filesB + 1;
          }
          return filesA > filesB ? -1 : 1;
        });
      }
    }
  } else {
    sortedData.sort((a, b) =>
      parseFloat(a.PUNCTAJ_TOTAL) > b.PUNCTAJ_TOTAL ? -1 : 1
    );
  }

  return (
    <div className="px-2 py-10">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold text-gray-900">
              Lista firme
            </h1>
          </div>
        </div>
        <div className="-mx-4 mt-8 sm:-mx-0">
          <table className="min-w-full divide-y divide-gray-300">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900"
                >
                  <span
                    onClick={() => {
                      handleSort("nume");
                    }}
                    className="flex cursor-pointer"
                  >
                    Nume
                    <span className="ml-1">
                      <div className="flex flex-col">
                        <ChevronUpIcon
                          className={
                            "h-3 w-3 rounded-t " +
                            (sortConfig.active &&
                            sortConfig.key == "nume" &&
                            sortConfig.direction == "asc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                        <ChevronDownIcon
                          className={
                            "h-3 w-3 rounded-b " +
                            (sortConfig.active &&
                            sortConfig.key == "nume" &&
                            sortConfig.direction == "desc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                      </div>
                    </span>
                  </span>
                </th>
                <th
                  scope="col"
                  className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
                >
                  <span
                    onClick={() => {
                      handleSort("cui");
                    }}
                    className="flex cursor-pointer"
                  >
                    CUI
                    <span className="ml-1">
                      <div className="flex flex-col">
                        <ChevronUpIcon
                          className={
                            "h-3 w-3 rounded-t " +
                            (sortConfig.active &&
                            sortConfig.key == "cui" &&
                            sortConfig.direction == "asc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                        <ChevronDownIcon
                          className={
                            "h-3 w-3 rounded-b " +
                            (sortConfig.active &&
                            sortConfig.key == "cui" &&
                            sortConfig.direction == "desc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                      </div>
                    </span>
                  </span>
                </th>
                <th
                  scope="col"
                  className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
                >
                  <span
                    onClick={() => {
                      handleSort("judet");
                    }}
                    className="flex cursor-pointer"
                  >
                    Judet
                    <span className="ml-1">
                      <div className="flex flex-col">
                        <ChevronUpIcon
                          className={
                            "h-3 w-3 rounded-t " +
                            (sortConfig.active &&
                            sortConfig.key == "judet" &&
                            sortConfig.direction == "asc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                        <ChevronDownIcon
                          className={
                            "h-3 w-3 rounded-b " +
                            (sortConfig.active &&
                            sortConfig.key == "judet" &&
                            sortConfig.direction == "desc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                      </div>
                    </span>
                  </span>
                </th>
                <th
                  scope="col"
                  className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
                >
                  <span
                    onClick={() => {
                      handleSort("buget_inainte");
                    }}
                    className="flex cursor-pointer"
                  >
                    Buget inainte
                    <span className="ml-1">
                      <div className="flex flex-col">
                        <ChevronUpIcon
                          className={
                            "h-3 w-3 rounded-t " +
                            (sortConfig.active &&
                            sortConfig.key == "buget_inainte" &&
                            sortConfig.direction == "asc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                        <ChevronDownIcon
                          className={
                            "h-3 w-3 rounded-b " +
                            (sortConfig.active &&
                            sortConfig.key == "buget_inainte" &&
                            sortConfig.direction == "desc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                      </div>
                    </span>
                  </span>
                </th>
                <th
                  scope="col"
                  className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
                >
                  <span
                    onClick={() => {
                      handleSort("buget_dupa");
                    }}
                    className="flex cursor-pointer"
                  >
                    Buget dupa
                    <span className="ml-1">
                      <div className="flex flex-col">
                        <ChevronUpIcon
                          className={
                            "h-3 w-3 rounded-t " +
                            (sortConfig.active &&
                            sortConfig.key == "buget_dupa" &&
                            sortConfig.direction == "asc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                        <ChevronDownIcon
                          className={
                            "h-3 w-3 rounded-b " +
                            (sortConfig.active &&
                            sortConfig.key == "buget_dupa" &&
                            sortConfig.direction == "desc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                      </div>
                    </span>
                  </span>
                </th>
                <th
                  scope="col"
                  className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
                >
                  <span
                    onClick={() => {
                      handleSort("trimis_la");
                    }}
                    className="flex cursor-pointer"
                  >
                    Trimis la
                    <span className="ml-1">
                      <div className="flex flex-col">
                        <ChevronUpIcon
                          className={
                            "h-3 w-3 rounded-t " +
                            (sortConfig.active &&
                            sortConfig.key == "trimis_la" &&
                            sortConfig.direction == "asc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                        <ChevronDownIcon
                          className={
                            "h-3 w-3 rounded-b " +
                            (sortConfig.active &&
                            sortConfig.key == "trimis_la" &&
                            sortConfig.direction == "desc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                      </div>
                    </span>
                  </span>
                </th>

                <th
                  scope="col"
                  className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
                >
                  <span
                    onClick={() => {
                      handleSort("nr_dosare");
                    }}
                    className="flex cursor-pointer"
                  >
                    Nr. Dosare Aprox.
                    <span className="ml-1">
                      <div className="flex flex-col">
                        <ChevronUpIcon
                          className={
                            "h-3 w-3 rounded-t " +
                            (sortConfig.active &&
                            sortConfig.key == "nr_dosare" &&
                            sortConfig.direction == "asc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                        <ChevronDownIcon
                          className={
                            "h-3 w-3 rounded-b " +
                            (sortConfig.active &&
                            sortConfig.key == "nr_dosare" &&
                            sortConfig.direction == "desc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                      </div>
                    </span>
                  </span>
                </th>
                <th
                  scope="col"
                  className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
                >
                  <span
                    onClick={() => {
                      handleSort("punctajab");
                    }}
                    className="flex cursor-pointer"
                  >
                    Punctaj A+B
                    <span className="ml-1">
                      <div className="flex flex-col">
                        <ChevronUpIcon
                          className={
                            "h-3 w-3 rounded-t " +
                            (sortConfig.active &&
                            sortConfig.key == "punctajab" &&
                            sortConfig.direction == "asc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                        <ChevronDownIcon
                          className={
                            "h-3 w-3 rounded-b " +
                            (sortConfig.active &&
                            sortConfig.key == "punctajab" &&
                            sortConfig.direction == "desc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                      </div>
                    </span>
                  </span>
                </th>
                <th
                  scope="col"
                  className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
                >
                  <span
                    onClick={() => {
                      handleSort("punctaj_dosare");
                    }}
                    className="flex cursor-pointer"
                  >
                    Punctaj dosare
                    <span className="ml-1">
                      <div className="flex flex-col">
                        <ChevronUpIcon
                          className={
                            "h-3 w-3 rounded-t " +
                            (sortConfig.active &&
                            sortConfig.key == "punctaj_dosare" &&
                            sortConfig.direction == "asc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                        <ChevronDownIcon
                          className={
                            "h-3 w-3 rounded-b " +
                            (sortConfig.active &&
                            sortConfig.key == "punctaj_dosare" &&
                            sortConfig.direction == "desc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                      </div>
                    </span>
                  </span>
                </th>

                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  <span
                    onClick={() => {
                      handleSort("punctaj_total");
                    }}
                    className="flex cursor-pointer"
                  >
                    Punctaj total
                    <span className="ml-1">
                      <div className="flex flex-col">
                        <ChevronUpIcon
                          className={
                            "h-3 w-3 rounded-t " +
                            (sortConfig.active &&
                            sortConfig.key == "punctaj_total" &&
                            sortConfig.direction == "asc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                        <ChevronDownIcon
                          className={
                            "h-3 w-3 rounded-b " +
                            (sortConfig.active &&
                            sortConfig.key == "punctaj_total" &&
                            sortConfig.direction == "desc"
                              ? "bg-blue-200"
                              : "bg-gray-100")
                          }
                          aria-hidden="true"
                        />
                      </div>
                    </span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {sortedData
                // .sort((a, b) => {
                //   // by select
                //   if (a.SELECTED && !b.SELECTED) {
                //     return -1;
                //   }
                // })
                // .sort((a, b) => {
                //   // by punctaj total
                //   if (a["PUNCTAJ_TOTAL"] > b["PUNCTAJ_TOTAL"]) {
                //     return -1;
                //   }
                //   if (a["PUNCTAJ_TOTAL"] < b["PUNCTAJ_TOTAL"]) {
                //     return 1;
                //   }
                //   return 0;
                // })
                .map((company) => (
                  <tr
                    key={company.CUI}
                    className={company.SELECTED ? "bg-green-100 px-1" : "px-1"}
                  >
                    <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none">
                      {company.NUME}
                      <dl className="font-normal lg:hidden">
                        <dt className="sr-only">Title</dt>
                        <dd className="mt-1 truncate text-gray-700">
                          {company.CUI}
                        </dd>
                        <dt className="sr-only sm:hidden">Email</dt>
                        <dd className="mt-1 truncate text-gray-500 sm:hidden">
                          {company.JUDET}
                        </dd>
                      </dl>
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell w-[50px] truncate ">
                      {company.CUI}
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">
                      {company.JUDET}
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">
                      {company.BUGET_INAINTE}
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">
                      {company.BUGET_DUPA}
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">
                      {company.TRIMIS_LA
                        ? moment(
                            company.TRIMIS_LA,
                            "DD-MM-YYYY HH:mm:ss.SSS"
                          ).format("DD-MM-YYYY")
                        : ""}
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">
                      {parseFloat(company.NR_DOSARE).toFixed(1)}
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">
                      {parseFloat(company["PunctajA+B"])?.toFixed(4)}
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">
                      {company["PUNCTAJ_DOSARE"]?.toFixed(4)}
                    </td>
                    <td className="px-3 py-4 text-sm text-gray-500">
                      {company["PUNCTAJ_TOTAL"]?.toFixed(4)}
                      {company.NOT_SURE == 1 ? (
                        <span className="ml-1 inline-flex items-center gap-x-1.5 rounded-full bg-red-100 px-2 py-1 text-xs font-medium text-red-700">
                          <svg
                            viewBox="0 0 6 6"
                            aria-hidden="true"
                            className="size-1.5 fill-red-500"
                          >
                            <circle r={3} cx={3} cy={3} />
                          </svg>
                          Nesigur
                        </span>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default App;
